module.exports = __webpack_public_path__ + "static/stats2@2x-ed311a628002f546494832053a7420a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/trusona/stats2@2x.jpg
// module id = 421
// module chunks = 3627797113349 20562973939449 33019919093843